import { useEffect } from "react";
import { Navigate, Outlet, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Stack } from "@mui/material";
import AdminLayout from "./adminLayout";
import Header from "../component/header";
import Footer from "../component/footer";
import { getMyRequest, getRolesRequest } from "../redux/modules/permissions/slice";

export default function Layout({ layoutName, proctedRoute = false }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { isLoggedIn, userData } = useSelector((state) => state.auth);
    const { myPermissions, roles } = useSelector((state) => state.permissions);

    useEffect(() => {
        if (isLoggedIn && userData?.role) {
            if (!myPermissions) {
                dispatch(getMyRequest({ role: userData.role }));
            }
            if (!roles || roles.length === 0) {
                dispatch(getRolesRequest());
            }
        }
    }, [isLoggedIn, userData, myPermissions, roles, dispatch]);

    // Keep permissions fresh on navigation. myPermissions is loaded once at
    // login, so without this an admin's change to a role (e.g. revoking the
    // settings module) wouldn't reach an already-logged-in user until they
    // re-login. Re-fetching here applies it on the next page change; the
    // success reducer replaces the value in place, so there's no nav flicker.
    useEffect(() => {
        if (isLoggedIn && userData?.role) {
            dispatch(getMyRequest({ role: userData.role }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);

    useEffect(() => {
        if (proctedRoute && !isLoggedIn) {
            navigate("/login");
        }
    }, [navigate, proctedRoute, isLoggedIn]);

    if (proctedRoute && !isLoggedIn) {
        return <Navigate to="login" />;
    }

    if (layoutName === "admin") {
        return (<AdminLayout><Outlet /></AdminLayout>);
    }

    if (layoutName === "auth") {
        return (
            <Stack sx={{ height: "100vh" }} justifyContent="center">
                <Outlet />
            </Stack>
        );
    }
    return (
        <>
            <Header />
            <Outlet />
            <Footer />
        </>
    );
}
